import styles from './hero.module.css';
import generalStyles from '../../../index.module.css';

import { Element } from 'react-scroll';
import { useTranslation } from 'react-i18next';
import { AnimatedPart } from '../../../components/animatedPart/AnimatedPart';
import { SocialIcons } from '../../../components/socialIcons/SocialIcons';

export const Hero = ({ openClosePopup }: { openClosePopup: () => void }) => {
    const { t } = useTranslation();

    return (
        <section id="section-hero">
            <Element name="home" className={styles.hero}>
                <div className={generalStyles.container}>
                    <div className={styles.hero__content}>
                        <div className={styles.text}>
                            <AnimatedPart>
                                <h1
                                    className={`${styles.heading} animated-items`}
                                >
                                    {t('hero.danceShowForYourEvent')}
                                </h1>
                            </AnimatedPart>
                            <AnimatedPart delay="2.5s">
                                <button
                                    className={styles.bookBtn}
                                    onClick={openClosePopup}
                                >
                                    {t('contactFormBookEvent.bookNow')}
                                </button>
                            </AnimatedPart>
                        </div>

                        <div className={styles.socialsInFooter}>
                            <SocialIcons />
                        </div>
                    </div>
                </div>
            </Element>
        </section>
    );
};
